import { Injectable } from "@angular/core";
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ShipmentWarningsTemplate } from "../../../models/SCMTemplates";
import { TemplatesService } from "../../../services/templates.service";

@Injectable()
export class ShipmentWarningsTemplatesResolver implements Resolve<Array<ShipmentWarningsTemplate>> {

    resolve(): Observable<Array<ShipmentWarningsTemplate>> {
        return this.templatesService.getShipmentWarningsTemplates();
    }

    constructor(private templatesService: TemplatesService) { }
}